import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllUsers();
        await this.GetAllSubscriptionsTypes();


        this.GetInfo(); 
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);   
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  الإشتراكات    ',
            ScreenTitleSingle: ' إشتراك ',
            ScreenTitleSingleAl: 'الإشتراك  ',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem:'',
            ByUserId:'',
            BySubscriptionsTypesId:'',

            ruleForm: {
                Id: '',
                UserId: '',
                SubscriptionsTypesId: '',
                Paid: '',
            },
            rules: {
                UserId: this.$helper.Required(),
                SubscriptionsTypesId: this.$helper.Required(),
                Paid: this.$helper.Required(),
            },


            Installments: [],

            InstallmentsruleForm: {
                Id: '',
                Value: '',
                SubscriptionsId: '',
            },

            Installmentsrules: {
                Value: this.$helper.Required(),
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetSubscriptions(this.pageNo, this.pageSize, this.Search, this.UserId, this.BySubscriptionsTypesId)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);

                    if (!this.ruleForm.Paid) {
                        this.ruleForm.Paid = Number(0);
                    } else {
                        this.ruleForm.Paid = Number(this.ruleForm.Paid);
                    }
                    
                    this.$blockUI.Start();
                    this.$http.AddSubscriptions(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteSubscriptions(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },




        GetInstallments() {
            this.$blockUI.Start();
            this.$http.GetInstallments(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Installments = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        OpentInstallmentsDialog(item) {
            this.SelectedItem = item;
            this.ClearForm(this.InstallmentsruleForm);
            this.GetInstallments();
        },

        submitInstallmentForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    this.InstallmentsruleForm.Id = Number(0);
                    this.InstallmentsruleForm.Value = Number(this.InstallmentsruleForm.Value);
                    this.InstallmentsruleForm.SubscriptionsId = this.SelectedItem.id;


                    this.$blockUI.Start();
                    this.$http.AddInstallments(this.InstallmentsruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetInstallments();
                            this.ClearForm(this.InstallmentsruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.state = 0;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        DeleteInstallment(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInstallments(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.GetInstallments();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

    }
}
